import React from 'react';

const TableForDesktopAndMobile = props => {
  const {
    tableItems,
    properties,
    desktopClassName = '',
    mobileClassName = '',
    id
  } = props;

  return (
    <React.Fragment>
      <table
        //* DESKTOP
        className={
          desktopClassName
            ? desktopClassName
            : 'hidden sm:table text-xs sm:text-base'
        }
        id={id + '-desktop'}
      >
        <tbody>
          <tr>
            {properties.map((property, property_index) => {
              let spacingArray = [];
              if (property_index !== 0) spacingArray.push('pl-4');
              const spacing = spacingArray.join(' ');
              return (
                <th key={property_index} className={`text-left ${spacing}`}>
                  {property.title}
                </th>
              );
            })}
          </tr>
          {tableItems.map((tableItem, tableItem_index) => {
            return (
              <tr key={tableItem_index}>
                {properties.map((property, property_index) => {
                  let spacingArray = ['pt-2'];
                  if (property_index !== 0) spacingArray.push('pl-4');
                  const spacing = spacingArray.join(' ');
                  return (
                    <td key={property_index} className={`${spacing}`}>
                      {property.value(tableItem)}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>

      <table
        //* MOBILE
        className={
          mobileClassName ? mobileClassName : 'sm:hidden text-xs sm:text-sm'
        }
        id={id + '-mobile'}
      >
        {tableItems.map((tableItem, tableItem_index) => {
          return (
            <tbody
              key={tableItem_index}
              className='[&:not(:first-child)]:border-t text-base'
            >
              {properties.map((property, property_index) => {
                let spacingList = [];
                if (property_index === 0 && tableItem_index !== 0)
                  spacingList.push('pt-4');
                if (
                  property_index === properties.length - 1 &&
                  tableItem_index !== tableItems.length - 1
                )
                  spacingList.push('pb-4');

                const spacing = spacingList.join(' ');
                return (
                  <tr key={property_index} className=''>
                    <td className={`font-semibold align-text-top ${spacing}`}>
                      {property.title}
                    </td>
                    <td className={`pl-4 align-text-top ${spacing}`}>
                      {property.value(tableItem)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          );
        })}
      </table>
    </React.Fragment>
  );
};

export default TableForDesktopAndMobile;
